import { createAsyncThunk } from "@reduxjs/toolkit";
import { UnidadeUFC } from "model/ufc/UnidadeUFC";
import { Api } from "service/api/Api";
import { ApiUnidadesUFC } from "service/api/ufc/ApiUnidadesUFC";
import { RootState } from "store/store";
import { EstadoRequisicao } from "store/types";
import { ErrosUtils } from "util/ErrosUtils";
import { CacheUnidadeUFC, UnidadesUFCState } from "./UnidadesUFC.types";



export class UnidadesUFCAction {
  static readonly carregar = createAsyncThunk(
    'UnidadesUFC/carregar',
    async (_, {getState, rejectWithValue, requestId}) => {
      const { unidadesUFC: estado } = getState() as RootState

      if (isEvitarRequisicao(estado, requestId)) {
        return;
      }

      // FIXME: Pegar o reino do state
      const REITORIA = 394;
      try {
        const unidades = await ApiUnidadesUFC.getEstruturaOrganizacional(Api.REINO_PADRAO, REITORIA)
        return {
          unidades: unidades,
          cache: gerarCache(unidades),
        }
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  )
}

function gerarCache(unidade: UnidadeUFC): CacheUnidadeUFC {
  let aVerificar = [unidade];
  const cache: CacheUnidadeUFC = {};

  while (aVerificar.length > 0) {
    const atual = aVerificar.pop()!!;
    cache[atual.id] = atual;

    if (atual.unidades !== undefined && atual.unidades !== null) {
      aVerificar = aVerificar.concat(atual.unidades);
    }
  }

  return cache
}


function isEvitarRequisicao(estado: UnidadesUFCState, requestId: string): boolean {
  return estado.estado !== EstadoRequisicao.CARREGANDO
      || estado.currentRequestId !== requestId
}